import React, {FC, useEffect, Fragment} from 'react';
import WrapperPreloader from "../../components/WrapperPreloader";
import {connect} from "react-redux";
import ForYou from "../../components/Main/ForYou";
import {getRecommendedMixes, setIndexRecommendedMixes} from "../../modules/ForYou";
import NoMixesPreference from "../../components/Main/NoMixesPreference";
import {IMix} from "../../constants/types";

interface IForYouPage {
    isLoading: boolean,
    recommendedMixes: Array<IMix>,
    requestCompleted: boolean,
    getRecommendedMixes: any,
    setIndexMixes: any,
}

const ForYouPage: FC<IForYouPage> = ({
                                         isLoading,
                                         recommendedMixes,
                                         getRecommendedMixes,
                                         requestCompleted,
                                         setIndexMixes,
                                     }) => {

    useEffect(() => {
        if (!requestCompleted) {
            getRecommendedMixes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WrapperPreloader
            isLoading={isLoading}
            heightPreloader="calc(92vh - 52px)"
        >
            <Fragment>
                {
                    !recommendedMixes.length && requestCompleted
                        ? <NoMixesPreference/>
                        : <ForYou
                            tobacco={recommendedMixes}
                            setIndex={setIndexMixes}
                        />
                }
            </Fragment>
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.forYou.isLoading,
    recommendedMixes: state.forYou.recommendedMixes,
    requestCompleted: state.forYou.requestCompleted,
});

const mapDispatchToProps = (dispatch: any) => ({
    getRecommendedMixes: () => dispatch(getRecommendedMixes()),
    setIndexMixes: (id: number) => dispatch(setIndexRecommendedMixes(id)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ForYouPage);

